const userReducer = (state, action) => {

    switch (action.type) {
        case "INIT_USER":
            return { user: action.payload };
        case "CHANGE_USER":
            return { user: action.payload };            
        default:
            return { user: state.user }
    }
};
  
export default userReducer